import ShokzMember from '@theme/shokz-member';

if (!customElements.get('member-register')) {
    class MemberRegister extends HTMLElement {
        constructor() {
            super();
            this.steps = {
                email: 'email',
                verify: 'verify',
            };
            this.countdownSeconds = 60;
            this.resendDelayMs = 2000;

            this.countdownTimer = null;
            this.countdownRemaining = 0;

            this.hasSentCode = false;

            // data-* 在 constructor 阶段往往尚未就绪，须在 connectedCallback 中再次同步
            this.isPopupComponent = false;
            this.isLoginUser = false;
            this.loginCustomerEmail = '';

            this.popupCooldownHours = 3;
            this.popupStorageKey = 'member_register_popup_last_shown';

            this.popupClearCommand = 'clearMemberRegisterPopupCooldown';

            this.loginRedirectUrl = '/account/profile';
            this.isSendingCode = false;
            this.isSubmittingCode = false;
            this.verifySubmitLoading = false;
            this.emailSubmitLoading = false;
            this.toastHideTimer = null;

            // ========== 日志开关 ==========
            this.debug = false;
        }

        // ========== 中文日志方法 ==========
        log() {
            if (!this.debug) return;
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[会员注册组件]');
            console.log.apply(console, args);
        }

        // 提交注册等关键接口时始终输出，便于在控制台核对请求体（调试时取消注释）
        /*
        logAlways() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[会员注册组件]');
            console.log.apply(console, args);
        }
        */

        cacheDomRefs() {
            this.root = this;
            this.panel = this.querySelector('.member-register__panel');
            this.closeBtn = this.querySelector('.member-register__close');
            this.backBtn = this.querySelector('.member-register__back');

            this.emailForm = this.querySelector('.member-register__form');
            this.verifyForm = this.querySelector('.member-register__verify_form');

            this.email = this.emailForm
                ? this.emailForm.querySelector('.member-register__input')
                : null;
            this.consent = this.emailForm
                ? this.emailForm.querySelector('.member-register__checkbox')
                : null;
            this.emailSubmit = this.emailForm
                ? this.emailForm.querySelector('.member-register__submit')
                : null;

            this.verifyInputs = this.verifyForm
                ? Array.from(
                    this.verifyForm.querySelectorAll(
                        '.member-register__verify_form__input__field'
                    )
                )
                : [];
            this.verifySubmit = this.verifyForm
                ? this.verifyForm.querySelector('.member-register__submit')
                : null;
            this.verifyError = this.verifyForm
                ? this.verifyForm.querySelector('.member-register__verify_form__error')
                : null;
            this.verifyErrorDefaultText = this.verifyError
                ? String(this.verifyError.textContent || '')
                : '';

            this.verifyAction = this.verifyForm
                ? this.verifyForm.querySelector(
                    '.member-register__verify_form__header__action'
                )
                : null;
            this.verifyCountdown = this.verifyForm
                ? this.verifyForm.querySelector(
                    '.member-register__verify_form__header__action__countdown'
                )
                : null;
            this.verifyResend = this.verifyForm
                ? this.verifyForm.querySelector(
                    '.member-register__verify_form__header__action__resend'
                )
                : null;

            this.benefitsLink = this.querySelector('.member-register__benefits');

            this.tipsContainer = this.querySelector('member-register-tips-container');
            this.tipCodeSent = this.tipsContainer
                ? this.tipsContainer.querySelector('[data-member-register-tip="code-sent"]')
                : null;
            this.tipSuccess = this.tipsContainer
                ? this.tipsContainer.querySelector('[data-member-register-tip="success"]')
                : null;
            this.tipSendCodeError = this.tipsContainer
                ? this.tipsContainer.querySelector('[data-member-register-tip="send-code-error"]')
                : null;
            this.tipAccountMismatch = this.tipsContainer
                ? this.tipsContainer.querySelector('[data-member-register-tip="account-mismatch"]')
                : null;
            this.tipAlreadyMember = this.tipsContainer
                ? this.tipsContainer.querySelector('[data-member-register-tip="already-member"]')
                : null;

            this.toastNodes = [
                this.tipCodeSent,
                this.tipSuccess,
                this.tipSendCodeError,
                this.tipAccountMismatch,
                this.tipAlreadyMember,
            ];
        }

        connectedCallback() {
            this.log('组件已挂载 connectedCallback');

            this.isPopupComponent = this.getAttribute('data-popup') === 'true';
            this.isLoginUser = this.getAttribute('data-login-status') === 'true';
            this.loginCustomerEmail =
                this.getAttribute('data-customer-email') || this.dataset.customerEmail || '';

            this.log(
                '来自属性的状态：data-popup=',
                this.isPopupComponent,
                'data-login-status=',
                this.isLoginUser,
                '已登录且带邮箱=',
                Boolean(String(this.loginCustomerEmail || '').trim())
            );

            this.cacheDomRefs();

            this.sync = this.sync.bind(this);
            this.handleClose = this.handleClose.bind(this);
            this.handleBack = this.handleBack.bind(this);
            this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
            this.handleVerifySubmit = this.handleVerifySubmit.bind(this);
            this.handleSubmitClick = this.handleSubmitClick.bind(this);
            this.handleResend = this.handleResend.bind(this);
            this.handleVerifyInput = this.handleVerifyInput.bind(this);
            this.handleVerifyKeydown = this.handleVerifyKeydown.bind(this);
            this.handleVerifyPaste = this.handleVerifyPaste.bind(this);
            this.handleVerifyFocus = this.handleVerifyFocus.bind(this);
            this.handleVerifyBlur = this.handleVerifyBlur.bind(this);
            this.handleBenefitsClick = this.handleBenefitsClick.bind(this);

            if (this.email) {
                this.email.addEventListener('input', this.sync);
                this.email.addEventListener('blur', this.sync);
                this.log('已绑定邮箱输入框事件');
            } else {
                this.log('未找到邮箱输入框');
            }

            if (this.consent) {
                this.consent.addEventListener('change', this.sync);
                this.log('已绑定勾选框事件');
            } else {
                this.log('未找到勾选框');
            }

            if (this.closeBtn) {
                this.closeBtn.addEventListener('click', this.handleClose);
                this.log('已绑定关闭按钮事件');
            } else {
                this.log('未找到关闭按钮');
            }

            if (this.backBtn) {
                this.backBtn.addEventListener('click', this.handleBack);
                this.log('已绑定返回按钮事件');
            } else {
                this.log('未找到返回按钮');
            }

            if (this.emailForm) {
                this.emailForm.addEventListener('submit', this.handleEmailSubmit);
                this.log('已绑定邮箱表单提交事件');
            } else {
                this.log('未找到邮箱表单');
            }

            if (this.verifyForm) {
                this.verifyForm.addEventListener('submit', this.handleVerifySubmit);
                this.log('已绑定验证码表单提交事件（仅拦截默认提交，步骤已停用）');
            } else {
                this.log('未找到验证码表单');
            }

            /*
            旧验证码步骤：resend / 输入框事件已停用，恢复流程时取消注释
            if (this.verifyResend) {
                this.verifyResend.addEventListener('click', this.handleResend);
                this.log('已绑定重新发送按钮事件');
            } else {
                this.log('未找到重新发送按钮');
            }
            */

            if (this.benefitsLink) {
                this.benefitsLink.addEventListener('click', this.handleBenefitsClick);
                this.log('已绑定 Explore Membership Benefits 链接事件');
            }

            /*
            if (this.verifyInputs.length) {
                this.verifyInputs.forEach((inputEl, index) => {
                    inputEl.addEventListener('input', this.handleVerifyInput);
                    inputEl.addEventListener('keydown', this.handleVerifyKeydown);
                    inputEl.addEventListener('paste', this.handleVerifyPaste);
                    inputEl.addEventListener('focus', this.handleVerifyFocus);
                    inputEl.addEventListener('blur', this.handleVerifyBlur);
                    this.log('已绑定验证码输入框事件，索引：', index);
                });
            } else {
                this.log('未找到验证码输入框');
            }
            */

            this.log('验证码输入框与重发按钮事件绑定已跳过（主流程为邮箱直达注册；恢复时取消上方注释）');

            this.root.addEventListener('click', this.handleSubmitClick);
            this.log('已绑定根节点点击代理事件');

            this.sync();
            this.syncVerifySubmit();
            this.syncCountdownFromDataset();

            this.log('初始化完成');
            void this.initializeVisibility();
        }

        disconnectedCallback() {
            this.log('组件已卸载 disconnectedCallback');

            if (this.email) {
                this.email.removeEventListener('input', this.sync);
                this.email.removeEventListener('blur', this.sync);
                this.log('已解绑邮箱输入框事件');
            }

            if (this.consent) {
                this.consent.removeEventListener('change', this.sync);
                this.log('已解绑勾选框事件');
            }

            if (this.closeBtn) {
                this.closeBtn.removeEventListener('click', this.handleClose);
                this.log('已解绑关闭按钮事件');
            }

            if (this.backBtn) {
                this.backBtn.removeEventListener('click', this.handleBack);
                this.log('已解绑返回按钮事件');
            }

            if (this.emailForm) {
                this.emailForm.removeEventListener('submit', this.handleEmailSubmit);
                this.log('已解绑邮箱表单提交事件');
            }

            if (this.verifyForm) {
                this.verifyForm.removeEventListener('submit', this.handleVerifySubmit);
                this.log('已解绑验证码表单提交事件');
            }

            /*
            if (this.verifyResend) {
                this.verifyResend.removeEventListener('click', this.handleResend);
                this.log('已解绑重新发送按钮事件');
            }
            */

            if (this.benefitsLink) {
                this.benefitsLink.removeEventListener('click', this.handleBenefitsClick);
                this.log('已解绑 Explore Membership Benefits 链接事件');
            }

            /*
            if (this.verifyInputs.length) {
                this.verifyInputs.forEach((inputEl, index) => {
                    inputEl.removeEventListener('input', this.handleVerifyInput);
                    inputEl.removeEventListener('keydown', this.handleVerifyKeydown);
                    inputEl.removeEventListener('paste', this.handleVerifyPaste);
                    inputEl.removeEventListener('focus', this.handleVerifyFocus);
                    inputEl.removeEventListener('blur', this.handleVerifyBlur);
                    this.log('已解绑验证码输入框事件，索引：', index);
                });
            }
            */

            this.root.removeEventListener('click', this.handleSubmitClick);
            this.log('已解绑根节点点击代理事件');

            this.stopCountdown();
            this.log('已停止倒计时');

            if (this.toastHideTimer) {
                window.clearTimeout(this.toastHideTimer);
                this.toastHideTimer = null;
            }

            this.log('卸载清理完成');
        }

        getPopupCooldownMs() {
            return this.popupCooldownHours * 60 * 60 * 1000;
        }

        getLastPopupShownTime() {
            var raw = localStorage.getItem(this.popupStorageKey);
            var time = parseInt(raw || '', 10);

            if (!Number.isFinite(time)) return 0;
            return time;
        }

        setLastPopupShownTime() {
            localStorage.setItem(this.popupStorageKey, String(Date.now()));
        }

        canAutoShowPopup() {
            var lastTime = this.getLastPopupShownTime();
            if (!lastTime) return true;

            var diff = Date.now() - lastTime;
            return diff >= this.getPopupCooldownMs();
        }

        clearPopupCooldown() {
            localStorage.removeItem(this.popupStorageKey);
            this.log('已清除弹窗冷却记录，可立即自动弹出');
        }

        registerPopupDebugCommand() {
            var self = this;

            if (window[this.popupClearCommand]) return;

            window[this.popupClearCommand] = function () {
                self.clearPopupCooldown();

                console.log('[会员注册组件] 已清除弹窗限制（3小时冷却已重置），准备立即弹出');

                // 立刻弹出
                self.handleShow();

                // 重新写入弹出时间，避免刷新后又立刻弹出
                self.setLastPopupShownTime();
            };

            console.log(
                '[会员注册组件] 调试命令已注册：在控制台执行 window.' +
                this.popupClearCommand +
                '() 可清除弹窗冷却并立即弹出'
            );
        }

        autoShowPopupWhenReady() {
            if (!this.isPopupComponent) return;

            // 注册调试命令（方便测试）
            this.registerPopupDebugCommand();

            if (!this.canAutoShowPopup()) {
                this.log('Popup 模式：3小时内已弹出过，本次不自动弹出');
                return;
            }

            var self = this;

            var doShow = function () {
                self.log('Popup 模式：满足条件，自动弹出');
                self.handleShow();
                self.setLastPopupShownTime();
            };

            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                doShow();
            } else {
                window.addEventListener('DOMContentLoaded', doShow, { once: true });
            }
        }

        async initializeVisibility() {
            const hasLoginCustomerEmail = Boolean(String(this.loginCustomerEmail || '').trim());
            if (!this.isPopupComponent && this.isLoginUser && hasLoginCustomerEmail) {
                const directBenefitsPath = this.getBenefitsPath();
                this.log(
                    '满足直跳条件（data-popup=false、data-login-status=true、已登录且带邮箱=true），直接跳转 benefits：',
                    directBenefitsPath
                );
                window.location.assign(directBenefitsPath);
                return;
            }

            // Logged-in users who already have member info should not see this component.
            const shouldHide = await this.shouldHideForRegisteredLoginUser();
            if (shouldHide) {
                if (this.getAttribute('data-popup') === 'true') {
                    this.log('已登录且已注册会员，隐藏弹窗 member-register 组件');
                    this.classList.add('hidden');
                } else {
                    const benefitsPath = this.getBenefitsPath();
                    this.log('已登录且已注册会员：非弹窗场景直接跳转 benefits', benefitsPath);
                    window.location.assign(benefitsPath);
                }

                return;
            }

            this.autoShowPopupWhenReady();
        }

        async shouldHideForRegisteredLoginUser() {
            if (!this.isLoginUser) return false;

            const payload = await this.fetchMemberInfoSafe();
            if (!payload) {
                this.log('已登录：会员信息无可用 payload（见上方接口日志），不隐藏组件');
                return false;
            }

            const has = ShokzMember.hasMemberInfoPayload(payload);
            if (!has) {
                this.log(
                    '已登录：接口已返回但未判定为已注册会员（hasMemberInfoPayload=false），body 见上方「会员信息接口响应」'
                );
            }
            return has;
        }

        async fetchMemberInfoSafe(emailOverride) {
            const targetEmail = String(emailOverride || this.loginCustomerEmail || '').trim();
            if (!targetEmail) {
                this.log('会员信息接口请求跳过：缺少邮箱');
                return null;
            }

            const payload = await ShokzMember.getMemberInfoByEmail(targetEmail);
            this.log('会员信息接口响应：body:', payload);
            return payload;
        }

        isEmailValid() {
            if (!this.email) return false;
            if (this.email.value.trim() === '') return false;
            if (typeof this.email.checkValidity === 'function') {
                return this.email.checkValidity();
            }
            return true;
        }

        getSignupContentType() {
            return this.getAttribute('data-popup') === 'true'
                ? 'signup_popup'
                : 'signup_page';
        }

        pushMembershipSignup(payload) {
            ShokzMember.pushMembershipSignup({
                contentType: this.getAttribute('data-popup') === 'true' ? 'popup' : 'page',
                contentName: 'Membership_Page',
                payload: payload,
            });
        }

        getSignupPopupContentNameForCurrentStep() {
            var step = this.root.getAttribute('data-step') || this.steps.email;
            return step === this.steps.verify
                ? 'login_verification_code_step'
                : 'login_email_step';
        }

        pushSignupPopupSelectContent(contentName, buttonName) {
            if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
                this.log('GA4 埋点跳过：window.dataLayer 不可用');
                return;
            }
            var contentType = this.getSignupContentType();
            window.dataLayer.push({ event_parameters: null });
            window.dataLayer.push({
                event: 'ga4Event',
                event_name: 'select_content',
                event_parameters: {
                    content_type: contentType,
                    content_name: contentName,
                    button_name: buttonName,
                },
            });
            this.log(
                'GA4 select_content：content_type=',
                contentType,
                'content_name=',
                contentName,
                'button_name=',
                buttonName
            );
        }

        sync() {
            if (!this.emailSubmit) return;

            if (this.emailSubmitLoading) {
                this.emailSubmit.disabled = true;
                return;
            }

            var ok =
                this.isEmailValid() && this.consent && this.consent.checked === true;

            this.emailSubmit.disabled = !ok;

            this.log('同步邮箱按钮状态：', ok ? '可点击' : '不可点击');
        }

        handleClose() {
            this.pushSignupPopupSelectContent(
                this.getSignupPopupContentNameForCurrentStep(),
                'Close'
            );
            this.log('点击关闭按钮，组件隐藏');
            this.parentElement.classList.add('hidden');
        }

        handleBenefitsClick() {
            this.pushSignupPopupSelectContent(
                this.getSignupPopupContentNameForCurrentStep(),
                'Explore_Membership_Benefits'
            );
        }

        handleShow() {
            this.log('组件显示');
            this.parentElement.classList.remove('hidden');
        }

        handleBack(e) {
            e.preventDefault();
            this.log('点击返回按钮（旧验证码步骤 UI）：返回邮箱步骤并清空验证码输入框');

            this.resetVerifyInputs(); // 清空所有验证码 input
            this.showVerifyError(false);
            this.hideAllRegisterToasts(true);
            this.hasSentCode = false;

            this.root.setAttribute('data-step', this.steps.email);
        }

        // ========== Countdown ==========

        isCounting() {
            return this.verifyAction && this.verifyAction.dataset.counting === 'true';
        }

        syncCountdownFromDataset() {
            if (!this.verifyAction) return;

            var counting = this.verifyAction.dataset.counting;
            var seconds = parseInt(this.verifyAction.dataset.countdown || '', 10);

            this.log('读取倒计时状态：counting =', counting, 'seconds =', seconds);

            if (counting === 'true') {
                this.log('检测到倒计时正在进行，继续倒计时');
                this.startCountdown(
                    Number.isFinite(seconds) && seconds > 0
                        ? seconds
                        : this.countdownSeconds
                );
                return;
            }

            if (counting === 'false') {
                this.log('检测到倒计时已结束，允许重新发送');
                if (this.verifyResend) this.verifyResend.disabled = false;
                return;
            }

            this.log('倒计时状态异常，强制设置为 false');
            this.setCounting(false);
        }

        setCounting(isCounting, secondsRemaining) {
            if (!this.verifyAction) return;

            var prev = this.verifyAction.dataset.counting;
            var next = isCounting ? 'true' : 'false';
            this.verifyAction.dataset.counting = next;

            if (typeof secondsRemaining === 'number') {
                this.verifyAction.dataset.countdown = String(secondsRemaining);
            }

            this.log('更新倒计时状态：', prev, '=>', next, '剩余秒数：', secondsRemaining);

            if (prev !== next) this.sync();
        }

        updateCountdownText(secondsRemaining) {
            if (!this.verifyCountdown) return;
            this.verifyCountdown.textContent = String(secondsRemaining) + 's';
            this.log('更新倒计时显示：剩余', secondsRemaining, '秒');
        }

        startCountdown(seconds) {
            if (!this.verifyAction) return;

            var startSeconds =
                Number.isFinite(seconds) && seconds > 0
                    ? seconds
                    : this.countdownSeconds;

            this.log('开始倒计时，初始秒数：', startSeconds);

            this.stopCountdown();
            this.countdownRemaining = startSeconds;

            this.setCounting(true, this.countdownRemaining);
            this.updateCountdownText(this.countdownRemaining);

            if (this.verifyResend) this.verifyResend.disabled = true;

            var self = this;
            this.countdownTimer = window.setInterval(function () {
                self.countdownRemaining = Math.max(
                    0,
                    (self.countdownRemaining || 0) - 1
                );

                self.setCounting(true, self.countdownRemaining);
                self.updateCountdownText(self.countdownRemaining);

                if (self.countdownRemaining <= 0) {
                    self.log('倒计时结束');

                    self.stopCountdown();
                    self.setCounting(false, 0);
                    self.updateCountdownText(0);

                    if (self.verifyResend) self.verifyResend.disabled = false;
                }
            }, 1000);
        }

        stopCountdown() {
            if (!this.countdownTimer) return;

            this.log('停止倒计时');
            window.clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }

        // ========== Verify ==========

        showVerifyError(show, text) {
            if (!this.verifyError) return;
            if (show) {
                if (typeof text === 'string' && text !== '') {
                    this.verifyError.textContent = text;
                } else {
                    this.verifyError.textContent = this.verifyErrorDefaultText;
                }
            } else {
                this.verifyError.textContent = this.verifyErrorDefaultText;
            }
            this.verifyError.style.display = show ? 'block' : 'none';
            this.log('验证码步骤错误提示（旧 UI）：', show ? '显示' : '隐藏');
        }

        hideAllRegisterToasts(immediate) {
            if (this.toastHideTimer) {
                window.clearTimeout(this.toastHideTimer);
                this.toastHideTimer = null;
            }

            (this.toastNodes || []).forEach(function (el) {
                if (!el) return;
                el.classList.remove('member-register__toast--show');
                if (immediate) {
                    el.hidden = true;
                } else {
                    window.setTimeout(function () {
                        if (!el.classList.contains('member-register__toast--show')) {
                            el.hidden = true;
                        }
                    }, 240);
                }
            });
        }

        showRegisterToast(kind) {
            const self = this;
            const map = {
                'code-sent': this.tipCodeSent,
                success: this.tipSuccess,
                'send-code-error': this.tipSendCodeError,
                'account-mismatch': this.tipAccountMismatch,
                'already-member': this.tipAlreadyMember,
            };
            const el = map[kind];
            if (!el) return;

            if (this.toastHideTimer) {
                window.clearTimeout(this.toastHideTimer);
                this.toastHideTimer = null;
            }

            (this.toastNodes || []).forEach(function (node) {
                if (!node || node === el) return;
                node.classList.remove('member-register__toast--show');
                node.hidden = true;
            });

            el.hidden = false;
            window.requestAnimationFrame(function () {
                el.classList.add('member-register__toast--show');
            });

            var ms = kind === 'success' ? 3200 : 4200;
            this.toastHideTimer = window.setTimeout(function () {
                el.classList.remove('member-register__toast--show');
                window.setTimeout(function () {
                    el.hidden = true;
                    self.toastHideTimer = null;
                }, 240);
            }, ms);
        }

        setSubmitLoading(button, loadingKey, loading, onIdle) {
            this[loadingKey] = !!loading;
            if (!button) return;

            button.classList.toggle(
                'member-register__submit--loading',
                this[loadingKey]
            );

            if (this[loadingKey]) {
                button.setAttribute('aria-busy', 'true');
                button.disabled = true;
            } else {
                button.removeAttribute('aria-busy');
                if (typeof onIdle === 'function') onIdle();
            }
        }

        setEmailSubmitLoading(loading) {
            this.setSubmitLoading(
                this.emailSubmit,
                'emailSubmitLoading',
                loading,
                () => this.sync()
            );
        }

        setVerifySubmitLoading(loading) {
            this.setSubmitLoading(
                this.verifySubmit,
                'verifySubmitLoading',
                loading,
                () => this.syncVerifySubmit()
            );
        }

        // 发码 URL：主流程不再请求，恢复验证码流程时仍可用
        getApiSendCodeUrl() {
            const explicit =
                this.getAttribute('data-send-code-url') || this.dataset.sendCodeUrl;
            if (explicit) return explicit;

            const proxyBase = this.getApiProxyBase();
            if (proxyBase) return this.joinUrl(proxyBase, '/api/v1/email/send-code');

            return (ShokzMember.baseUrl || '') + '/api/v1/email/send-code';
        }

        getLoginRedirectUrl() {
            return (
                this.getAttribute('data-login-redirect-url') ||
                this.dataset.loginRedirectUrl ||
                this.loginRedirectUrl
            );
        }

        normalizeShopifyRoot() {
            let root =
                window.Shopify?.routes?.root != null
                    ? window.Shopify.routes.root
                    : '/';
            root = String(root || '/');
            if (!root.endsWith('/')) root += '/';
            return root;
        }

        getBenefitsPath() {
            return this.normalizeShopifyRoot() + 'pages/shokzsquad-benefits';
        }

        getHomePath() {
            return this.normalizeShopifyRoot();
        }

        isRegisteredEmailSameAsLogin(registeredEmail) {
            var loginEmail = String(this.loginCustomerEmail || '').trim().toLowerCase();
            var registerEmail = String(registeredEmail || '').trim().toLowerCase();
            return !!loginEmail && !!registerEmail && loginEmail === registerEmail;
        }

        async getPostRegisterRedirectUrl(registeredEmail) {
            var benefitsPath = this.getBenefitsPath();

            if (this.isLoginUser) {
                return benefitsPath;
            }

            return (
                '/customer_authentication/login?return_to=' +
                encodeURIComponent(benefitsPath)
            );
        }

        getApiProxyBase() {
            return (
                this.getAttribute('data-api-proxy-base') || this.dataset.apiProxyBase || ''
            );
        }

        joinUrl(base, path) {
            var b = String(base || '').trim();
            var p = String(path || '').trim();
            if (!b) return p;
            if (!p) return b;
            if (b.endsWith('/')) b = b.slice(0, -1);
            if (!p.startsWith('/')) p = '/' + p;
            return b + p;
        }

        getApiHeaders() {
            return {
                accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Site': ShokzMember.baseHeaders['X-Site'],
                Authorization: ShokzMember.baseHeaders.Authorization,
            };
        }

        async parseJsonSafe(response) {
            try {
                return await response.json();
            } catch (e) {
                return null;
            }
        }

        async postApiJson(url, body) {
            var response;
            try {
                response = await fetch(url, {
                    method: 'POST',
                    headers: this.getApiHeaders(),
                    body: JSON.stringify(body || {}),
                });
            } catch (e) {
                var err = new Error(
                    '网络请求失败（可能被浏览器 CORS 拦截）。请改用同域代理地址（例如 /apps/...）或让接口返回 Access-Control-Allow-Origin'
                );
                err.status = 0;
                err.url = url;
                err.cause = e;
                throw err;
            }

            var payload = await this.parseJsonSafe(response);

            if (!response.ok) {
                var err = new Error(
                    '请求失败：HTTP ' + response.status + ' ' + response.statusText
                );
                err.status = response.status;
                err.payload = payload;
                err.url = url;
                throw err;
            }

            return payload;
        }

        // 发码：当前主流程不再调用，保留备查
        async fetchEmailVerifyCode(email) {
            const url = this.getApiSendCodeUrl();
            return await this.postApiJson(url, { email: email });
        }

        async submitEmailVerifyCode(email) {
            // 旧验证码流程请求体曾包含 code：{ email: email, code: code }
            return await ShokzMember.registerShopifyMember(email);
        }

        // 旧验证码流程：主流程已关闭，整段保留备查
        async requestVerifyCodeWithUi() {
            /*
            if (this.isSendingCode) {
                this.log('获取验证码被忽略：已有请求正在进行');
                return false;
            }

            if (!this.email) {
                this.log('获取验证码失败：未找到邮箱输入框');
                return false;
            }

            var email = String(this.email.value || '').trim();
            if (email === '') {
                this.log('获取验证码失败：邮箱为空');
                return false;
            }

            this.isSendingCode = true;
            if (this.verifyResend) this.verifyResend.disabled = true;

            try {
                var payload = await this.fetchEmailVerifyCode(email);
                this.log('获取验证码接口返回：', payload);

                if (payload && typeof payload.code === 'number' && payload.code !== 0) {
                    this.showRegisterToast('send-code-error');
                    return false;
                }

                this.showVerifyError(false);
                return true;
            } catch (e) {
                this.log('获取验证码请求异常：', e);
                this.showRegisterToast('send-code-error');
                return false;
            } finally {
                this.isSendingCode = false;
            }
            */
        }

        async submitVerifyCodeWithUi() {
            /*
            if (this.isSubmittingCode) {
                this.log('提交验证码被忽略：已有请求正在进行');
                return null;
            }

            if (!this.email) {
                this.log('提交验证码失败：未找到邮箱输入框');
                return null;
            }

            var email = String(this.email.value || '').trim();
            var code = this.getVerifyCode();

            if (email === '' || code === '') {
                this.log('提交验证码失败：邮箱或验证码为空');
                return null;
            }

            this.isSubmittingCode = true;
            if (this.verifySubmit) this.verifySubmit.disabled = true;

            try {
                var payload = await this.submitEmailVerifyCode(email, code);
                this.log('提交验证码接口返回：', payload);
                return payload;
            } catch (e) {
                this.log('提交验证码请求异常：', e);
                return {
                    code: -1,
                    message:
                        e && e.payload && e.payload.message
                            ? e.payload.message
                            : e && e.message
                                ? e.message
                                : '提交验证码失败',
                };
            } finally {
                this.isSubmittingCode = false;
                this.syncVerifySubmit();
            }
            */
        }

        getVerifyCode() {
            if (!this.verifyInputs.length) return '';
            return this.verifyInputs.map((inputEl) => inputEl.value).join('');
        }

        isVerifyCodeFilled() {
            if (!this.verifyInputs.length) return false;
            return this.verifyInputs.every((inputEl) => /^\d$/.test(inputEl.value));
        }

        syncVerifySubmit() {
            if (!this.verifySubmit) return;

            if (this.verifySubmitLoading) {
                this.verifySubmit.disabled = true;
                return;
            }

            var ok = this.isVerifyCodeFilled();
            this.verifySubmit.disabled = !ok;

            this.log('同步验证码提交按钮状态（旧步骤）：', ok ? '可点击' : '不可点击');
        }

        resetVerifyInputs() {
            if (!this.verifyInputs.length) return;

            this.log('清空验证码输入框');

            this.verifyInputs.forEach((inputEl) => {
                inputEl.value = '';
                inputEl.dataset.prevValue = '';

                var box = inputEl.closest('.member-register__verify_form__input__box');
                if (box) box.classList.remove('filled');
            });

            this.syncVerifySubmit();
        }

        focusVerifyInput(index) {
            if (!this.verifyInputs.length) return;

            var inputEl = this.verifyInputs[index];
            if (!inputEl) return;

            this.log('聚焦验证码输入框，索引：', index);

            inputEl.focus();
            if (typeof inputEl.select === 'function') inputEl.select();
        }

        // ========== Submit Handlers ==========

        async submitEmailFlow() {
            if (!this.isEmailValid() || !this.consent || this.consent.checked !== true) {
                this.log('邮箱提交失败：邮箱无效或未勾选协议');
                return;
            }

            if (this.emailSubmitLoading) {
                this.log('邮箱提交被忽略：请求进行中');
                return;
            }

            this.setEmailSubmitLoading(true);
            try {
                const registeredEmail = this.email ? this.email.value : '';
                if (
                    this.isLoginUser &&
                    !this.isRegisteredEmailSameAsLogin(registeredEmail)
                ) {
                    const homePath = this.getHomePath();
                    this.log('邮箱步骤校验失败：登录邮箱与注册邮箱不一致，提示后跳转首页', homePath);
                    this.showRegisterToast('account-mismatch');
                    window.setTimeout(function () {
                        window.location.assign(homePath);
                    }, 2000);
                    return;
                }

                if (!this.isLoginUser) {
                    const memberInfo = await this.fetchMemberInfoSafe(registeredEmail);
                    if (memberInfo && ShokzMember.hasMemberInfoPayload(memberInfo)) {
                        const benefitsPath = this.getBenefitsPath();
                        const loginRedirectUrl =
                            '/customer_authentication/login?return_to=' +
                            encodeURIComponent(benefitsPath);
                        this.log('邮箱已注册会员，提示后跳转登录：', loginRedirectUrl);
                        this.showRegisterToast('already-member');
                        window.setTimeout(function () {
                            window.location.assign(loginRedirectUrl);
                        }, 2000);
                        return;
                    }
                }

                this.log('邮箱步骤：直接请求注册接口（已跳过发码/验证码）');

                const emailTrim = String(this.email.value || '').trim();
                let payload;
                try {
                    payload = await this.submitEmailVerifyCode(emailTrim);
                    this.log('注册接口返回：', payload);
                } catch (e) {
                    this.log('注册请求异常：', e);
                    payload = {
                        code: -1,
                        message:
                            e && e.payload && e.payload.message
                                ? e.payload.message
                                : e && e.message
                                    ? e.message
                                    : '注册请求失败',
                    };
                }

                if (payload && payload.code === 0) {
                    this.pushSignupPopupSelectContent('Subscribe', 'join for free');
                    this.pushMembershipSignup(payload);
                    this.log('注册成功：', payload.message);
                    this.showVerifyError(false);
                    this.showRegisterToast('success');
                    this.root.dataset.registered = 'true';
                    this.root.dispatchEvent(
                        new CustomEvent('member-register:success', {
                            bubbles: true,
                            detail: payload.data || null,
                        })
                    );
                    const redirectUrl = await this.getPostRegisterRedirectUrl(
                        this.email ? this.email.value : ''
                    );
                    if (redirectUrl) {
                        this.log('注册成功，准备跳转：', redirectUrl);
                        window.setTimeout(function () {
                            window.location.assign(redirectUrl);
                        }, 1000);
                    }
                    return;
                }

                this.log('注册失败：', payload && payload.message);
                this.pushMembershipSignup(payload);
                this.showRegisterToast('send-code-error');

                /*
                旧流程（发验证码并进入验证码步骤）— 已停用，保留备查：
                this.log('邮箱步骤：请求验证码，成功后再进入验证码步骤');
                var ok = await this.requestVerifyCodeWithUi();
                if (!ok) {
                    this.log('获取验证码失败：停留在邮箱步骤');
                    return;
                }
                this.pushSignupPopupSelectContent('Subscribe', 'join for free');
                this.root.setAttribute('data-step', this.steps.verify);
                if (this.panel && this.email) {
                    var emailSpan = this.panel.querySelector(
                        '.member-register__step-verify .member-register__subtitle span'
                    );
                    if (emailSpan) emailSpan.textContent = this.email.value;
                }
                this.showVerifyError(false);
                this.resetVerifyInputs();
                this.hasSentCode = true;
                this.startCountdown(this.countdownSeconds);
                this.focusVerifyInput(0);
                this.showRegisterToast('code-sent');
                */
            } finally {
                this.setEmailSubmitLoading(false);
            }
        }

        async submitVerifyFlow(submitter) {
            /*
            if (submitter && this.verifyResend && submitter === this.verifyResend) {
                this.log('验证码提交被忽略：触发来源为重新发送按钮');
                return;
            }

            if (this.root.dataset.step !== this.steps.verify) {
                this.log('验证码提交被忽略：当前不在验证码步骤');
                return;
            }

            if (!this.isVerifyCodeFilled()) {
                this.log('验证码未填写完整，禁止提交');
                this.syncVerifySubmit();
                return;
            }

            var code = this.getVerifyCode();
            this.log('提交验证码：', code);

            this.setVerifySubmitLoading(true);
            try {
                var payload = await this.submitVerifyCodeWithUi();
                if (payload && payload.code === 0) {
                    this.pushSignupPopupSelectContent(
                        'login_verification_code_step',
                        'Join_For_Free'
                    );
                    this.log('验证码提交成功：', payload.message);
                    this.showVerifyError(false);
                    this.showRegisterToast('success');
                    this.root.dataset.registered = 'true';
                    this.root.dispatchEvent(
                        new CustomEvent('member-register:success', {
                            bubbles: true,
                            detail: payload.data || null,
                        })
                    );
                    var redirectUrl = await this.getPostRegisterRedirectUrl(
                        this.email ? this.email.value : ''
                    );
                    if (redirectUrl) {
                        this.log('注册成功，准备跳转：', redirectUrl);
                        window.setTimeout(function () {
                            window.location.assign(redirectUrl);
                        }, 1000);
                    }
                    return;
                }

                this.log('验证码提交失败，显示错误提示：', payload && payload.message);
                this.showVerifyError(true, 'Invalid verification code');

                this.resetVerifyInputs();
                this.focusVerifyInput(0);
            } finally {
                this.setVerifySubmitLoading(false);
            }
            */
        }

        handleSubmitClick(e) {
            var target = e.target;
            if (!(target instanceof Element)) return;

            var button = target.closest('.member-register__submit');
            if (!button || !(button instanceof HTMLButtonElement)) return;
            if (button.disabled) {
                this.log('按钮点击被忽略：按钮处于禁用状态');
                return;
            }

            var step = button.dataset.step;
            if (step !== this.steps.email && step !== this.steps.verify) {
                this.log('按钮点击被忽略：未知 step =', step);
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            this.log('点击提交按钮，step =', step);

            if (step === this.steps.email) {
                void this.submitEmailFlow();
                return;
            }

            if (step === this.steps.verify) {
                this.log('验证码步骤已停用，忽略提交（恢复流程时取消停用并取消下方注释）');
            }
            /*
            if (step === this.steps.verify) {
                void this.submitVerifyFlow(button);
            }
            */
        }

        handleEmailSubmit(e) {
            e.preventDefault();
            this.log('触发表单提交（邮箱步骤）');
            void this.submitEmailFlow();
        }

        handleVerifySubmit(e) {
            e.preventDefault();
            this.log('验证码表单提交已忽略（步骤已停用；恢复时取消 requestVerifyCodeWithUi 等注释并重新绑定事件）');
            /*
            this.log('触发表单提交（验证码步骤）');
            void this.submitVerifyFlow(e.submitter);
            */
        }

        async handleResend(e) {
            e.preventDefault();
            e.stopPropagation();
            /*
            this.log('点击重新发送验证码');

            if (!this.verifyResend) {
                this.log('重新发送失败：未找到 resend 按钮');
                return;
            }

            if (this.root.dataset.step !== this.steps.verify) {
                this.log('重新发送被忽略：当前不在验证码步骤');
                return;
            }

            if (this.isCounting()) {
                this.log('重新发送被忽略：倒计时尚未结束');
                return;
            }

            this.verifyResend.disabled = true;

            // join for free 按钮禁用
            if (this.verifySubmit) this.verifySubmit.disabled = true;

            this.log('重新发送按钮已禁用，开始获取验证码请求');

            var ok = await this.requestVerifyCodeWithUi();
            if (!ok) {
                this.log('重新发送失败：允许用户再次点击重试');
                if (this.verifyResend) this.verifyResend.disabled = false;
                this.syncVerifySubmit();
                return;
            }

            this.pushSignupPopupSelectContent(
                'login_verification_code_step',
                'Resend'
            );

            this.log('重新发送成功，清空输入框并重新开始倒计时');
            this.resetVerifyInputs();
            this.showVerifyError(false);
            this.showRegisterToast('code-sent');
            this.startCountdown(this.countdownSeconds);
            this.focusVerifyInput(0);
            this.syncVerifySubmit();
            */
        }

        // ========== Input Events ==========

        handleVerifyFocus(e) {
            var inputEl = e.target;
            var box = inputEl.closest('.member-register__verify_form__input__box');
            if (box) box.classList.add('focus');

            var idx = this.verifyInputs.indexOf(inputEl);
            this.log('验证码输入框获得焦点，索引：', idx);

        }

        handleVerifyBlur(e) {
            var inputEl = e.target;
            var box = inputEl.closest('.member-register__verify_form__input__box');
            if (box) box.classList.remove('focus');

            var idx = this.verifyInputs.indexOf(inputEl);
            this.log('验证码输入框失去焦点，索引：', idx);
        }

        handleVerifyPaste(e) {
            var inputEl = e.target;
            var idx = this.verifyInputs.indexOf(inputEl);
            if (idx < 0) return;

            var text =
                e.clipboardData && typeof e.clipboardData.getData === 'function'
                    ? e.clipboardData.getData('text/plain')
                    : '';
            var digits = String(text || '').replace(/\D/g, '');
            if (digits.length < 2) return;

            e.preventDefault();

            if (idx === 0) {
                this.verifyInputs.forEach(function (el) {
                    el.value = '';
                    el.dataset.prevValue = '';
                    var box = el.closest('.member-register__verify_form__input__box');
                    if (box) box.classList.remove('filled');
                });
            }

            var remaining = this.verifyInputs.length - idx;
            var slice = digits.slice(0, remaining);

            for (var i = 0; i < slice.length; i++) {
                var el = this.verifyInputs[idx + i];
                var ch = slice.charAt(i);
                el.value = ch;
                el.dataset.prevValue = ch;
                var box = el.closest('.member-register__verify_form__input__box');
                if (box) box.classList.toggle('filled', ch !== '');
            }

            this.log('验证码粘贴：自索引', idx, '填入', slice.length, '位');

            this.showVerifyError(false);
            this.syncVerifySubmit();

            var lastFilled = idx + slice.length - 1;
            var nextIdx = lastFilled + 1;
            window.setTimeout(
                function () {
                    if (nextIdx < this.verifyInputs.length) {
                        this.focusVerifyInput(nextIdx);
                    } else {
                        this.focusVerifyInput(lastFilled);
                    }
                }.bind(this),
                0
            );
        }

        handleVerifyInput(e) {
            var inputEl = e.target;
            var idx = this.verifyInputs.indexOf(inputEl);

            var raw = String(inputEl.value || '');
            var prev = String(inputEl.dataset.prevValue || '');

            var newDigit = '';
            var shouldJump = false;

            if (raw.length > prev.length) {
                // 场景 A：追加了字符 (例如：1 变成 12，或 21)
                // 剔除掉原有的部分，找出新增的部分
                var added = prev ? raw.replace(prev, '') : raw;
                var match = added.match(/\d/g);
                if (match) {
                    newDigit = match[match.length - 1]; // 永远取最新敲击的那个数字
                    shouldJump = true;
                } else {
                    // 如果追加的是非数字（比如拼音、字母），还原为原来的数字
                    newDigit = prev;
                }
            } else if (raw.length < prev.length) {
                // 场景 B：删减了字符 (如按了 Backspace)
                newDigit = '';
                shouldJump = false;
            } else {
                // 场景 C：长度没变 (通常是全选文本后直接输入，发生了覆盖)
                var match = raw.match(/\d/g);
                if (match) {
                    newDigit = match[match.length - 1];
                    shouldJump = true; // 只要能提取到数字，说明发生了重新输入，允许跳格
                } else {
                    newDigit = prev;
                }
            }

            // 赋值新数字并记录
            inputEl.value = newDigit;
            inputEl.dataset.prevValue = newDigit;

            var box = inputEl.closest('.member-register__verify_form__input__box');
            if (box) box.classList.toggle('filled', newDigit !== '');

            this.log('验证码输入变化：索引', idx, '新值：', newDigit);

            this.showVerifyError(false);
            this.syncVerifySubmit();

            // 如果成功输入了新数字，延迟跳转焦点
            if (shouldJump && newDigit !== '') {
                var self = this;
                window.setTimeout(function () {
                    var next = self.verifyInputs[idx + 1];
                    if (next) {
                        next.focus();
                    }
                }, 0); // 0ms 延迟足以避开移动端输入法的焦点混淆
            }
        }
        handleVerifyKeydown(e) {
            var inputEl = e.target;
            var idx = this.verifyInputs.indexOf(inputEl);

            if (idx < 0) return;

            this.log('验证码输入框按键事件：索引', idx, '按键：', e.key);

            // 删除了对 /^\d$/.test(e.key) 的拦截，让数字自然触发原生 input 事件

            if (e.key === 'Backspace') {
                if (inputEl.value === '' && idx > 0) {
                    e.preventDefault();
                    this.log('按下退格键，当前为空，跳转到前一个输入框');
                    this.focusVerifyInput(idx - 1);
                }
                return;
            }

            if (e.key === 'ArrowLeft' && idx > 0) {
                e.preventDefault();
                this.log('按下左方向键，跳转到前一个输入框');
                this.focusVerifyInput(idx - 1);
                return;
            }

            if (e.key === 'ArrowRight' && idx < this.verifyInputs.length - 1) {
                e.preventDefault();
                this.log('按下右方向键，跳转到后一个输入框');
                this.focusVerifyInput(idx + 1);
            }
        }
    }

    customElements.define('member-register', MemberRegister);
}

if (!customElements.get('member-register-tips-container')) {
    class MemberRegisterTipsContainer extends HTMLElement {
        constructor() {
            super();
        }
    }
    customElements.define('member-register-tips-container', MemberRegisterTipsContainer);
}
